// extracted by mini-css-extract-plugin
export default {"planetMintSuccess":"PlanetMintSuccess_planetMintSuccess__APIYj","mintWithCardContainer":"PlanetMintSuccess_mintWithCardContainer__ZkWSW","bottom":"PlanetMintSuccess_bottom__qYxUT"};